import { apiService } from "../../../services/apiService";
import { apiServiceConstants } from "../../../constants";
import { utilService } from "../../../services/utilService";

import {
  siteListResultInterface,
  RespSiteListModel,
} from "../../../pages/Sites/sites.model";
import {
  unitDeptListApiResponseInterface,
  unitDeptListResultInterface,
} from "../../../pages/UnitDeptList/UnitDept.modal";
import { unitDeptListService } from "../../../pages/UnitDeptList/UnitDept.service";

const setFavorite = (
  setSiteFav: boolean = true,
  params: any
): Promise<siteListResultInterface | unitDeptListResultInterface> => {
  if (setSiteFav) {
    return setFavSiteListData(params);
  } else {
    return setFavUnitsDeptList(params);
  }
};

const setFavUnitsDeptList = async (
  Params: any
): Promise<unitDeptListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/list/?reg_code=${utilService.getNetwork()}&siteId=${
        Params.siteId
      }`,
      Params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const siteListResp = res as unitDeptListApiResponseInterface;
      const unitListResponse =
        unitDeptListService.setUnitListModel(siteListResp);
      const deptListResponse =
        unitDeptListService.setDeptListModel(siteListResp);
      const result: unitDeptListResultInterface = {
        isSuccess: true,
        unitListResult: unitListResponse,
        deptListResult: deptListResponse,
        status: siteListResp.status,
        message: siteListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: unitDeptListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setFavSiteListData = async (
  Params: any
): Promise<siteListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/hospital/list/?reg_code=${utilService.getNetwork()}&siteId=${
        Params.siteId
      }`,
      Params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const siteListResp = res as RespSiteListModel;
      const siteListResponse = setSiteListModel(siteListResp);
      const result: siteListResultInterface = {
        isSuccess: true,
        siteListResult: siteListResponse,
        status: siteListResp.status,
        message: siteListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: siteListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setSiteListModel = (payload: any): any => {
  let SiteListArray = payload.result.map((object: any) => {
    return {
      id: object.siteId,
      name: object.siteName,
      location: object.location,
      isAssigned: object.isAssigned,
      fav: object.fav,
      contactDetails: object.contactDetails,
    };
  });
  return SiteListArray;
};

const handleErrorResponse = () => {};

export const setFavSiteListService = {
  setFavSiteListData,
  handleErrorResponse,
  setSiteListModel,
  setFavorite,
};
